import { render, staticRenderFns } from "./CreatePassword.vue?vue&type=template&id=f4e0402c&"
import script from "./CreatePassword.vue?vue&type=script&lang=ts&"
export * from "./CreatePassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports